<template>
  <component :is="tag" :class="[classes]"
  >
    <slot/>
  </component>
</template>

<script>

export default {
  name: 'VSpacer',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
  computed: {
    classes () {
      return {
        'spacer flex-grow-1 w-auto': true,
      }
    },
  }
};
</script>
